import { TranslatedLanguage } from '@/interface/common';

interface TranslationObject {
  en: string;
  fr: string;
  es: string;
}

export const getLocalizedContent = (
  translationString: string,
  language: TranslatedLanguage,
  fallback: string = '',
): string => {
  if (!translationString) {
    return fallback;
  }

  try {
    if (translationString.startsWith('{') && translationString.endsWith('}')) {
      const parsed: TranslationObject = JSON.parse(translationString);

      // Return the content for the specified language, fallback to English if not available
      const result = parsed[language] || parsed.en || fallback;

      return result;
    } else {
      return translationString;
    }
  } catch (error) {
    console.error('Error parsing translation string:', error);
    return fallback;
  }
};

export const getCurrentLanguage = (): TranslatedLanguage => {
  const storedLanguage = localStorage.getItem('i18nextLng');
  if (storedLanguage) {
    const lang = storedLanguage.slice(0, 2);
    // Validate that it's a valid language code
    if (lang === 'en') return TranslatedLanguage.en;
    if (lang === 'fr') return TranslatedLanguage.fr;
    if (lang === 'es') return TranslatedLanguage.es;
  }

  const browserLanguage = (navigator.language || 'en').slice(0, 2);
  // Validate that it's a valid language code
  if (browserLanguage === 'en') return TranslatedLanguage.en;
  if (browserLanguage === 'fr') return TranslatedLanguage.fr;
  if (browserLanguage === 'es') return TranslatedLanguage.es;

  return TranslatedLanguage.en;
};
